/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HoldsChallengeRequest
 */
export interface HoldsChallengeRequest {
    /**
     * Hours to respond to challenge
     * @type {number}
     * @memberof HoldsChallengeRequest
     */
    responseHours?: number;
}

/**
 * Check if a given object implements the HoldsChallengeRequest interface.
 */
export function instanceOfHoldsChallengeRequest(value: object): value is HoldsChallengeRequest {
    return true;
}

export function HoldsChallengeRequestFromJSON(json: any): HoldsChallengeRequest {
    return HoldsChallengeRequestFromJSONTyped(json, false);
}

export function HoldsChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldsChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'responseHours': json['response_hours'] == null ? undefined : json['response_hours'],
    };
}

  export function HoldsChallengeRequestToJSON(json: any): HoldsChallengeRequest {
      return HoldsChallengeRequestToJSONTyped(json, false);
  }

  export function HoldsChallengeRequestToJSONTyped(value?: HoldsChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response_hours': value['responseHours'],
    };
}

